import CustomEventProvider from "./Provider/CustomEvent";
import GA4Provider from "./Provider/GA4Event";
import AnalyticsService from "./Services/AnalyticsService";

const analytics = new AnalyticsService([new CustomEventProvider(),new GA4Provider()]);

export default analytics;